import { TemplateElement, html, defineElement } from '@webtides/element-js';

import { ComparisonService, ComparisonServiceEvents } from './ComparsionService';
export default class ComparisonCount extends TemplateElement {
    constructor() {
        super({ shadowRender: false });
    }

    properties() {
        return {
            count: false,
        };
    }

    connected() {
        this.updateCount();
    }

    async updateCount() {
        this.count = await ComparisonService.count();
    }

    events() {
        return {
            document: {
                [ComparisonServiceEvents.UPDATE]: e => {
                    this.updateCount();
                },
            },
        };
    }

    template() {
        if (!this.count) return '';

        return html` <div class="count">${this.count}</div> `;
    }
}

defineElement('comparison-count', ComparisonCount);
